export default __webpack_public_path__ + "static/media/elevate-lav-poster-1.2277ab3b.jpg";